module.exports = __webpack_public_path__ + "static/img/私域流量沉淀.22c531a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/私域流量沉淀.png
// module id = ZYLT
// module chunks = 0